import React from 'react';
export default function PageNotFound(){
    return(
        <center><p>404 Page Not Found</p></center>
    );
}